import { initializeApp } from "firebase/app";

const pwaConfig = {
  apiKey: "AIzaSyDxl-YKbcIp84f2rjENdySY6lJwVjQzrTU",
  authDomain: "circular-ufrn.firebaseapp.com",
  databaseURL: "https://circular-ufrn.firebaseio.com",
  projectId: "circular-ufrn",
  storageBucket: "circular-ufrn.appspot.com",
  messagingSenderId: "188902688357",
  appId: "1:188902688357:web:21d41ad9fd145659c0a88c",
  measurementId: "G-JTFR54YDDV",
};

const cordovaConfig = {
  apiKey: "AIzaSyDxl-YKbcIp84f2rjENdySY6lJwVjQzrTU",
  authDomain: "circular-ufrn.firebaseapp.com",
  databaseURL: "https://circular-ufrn.firebaseio.com",
  projectId: "circular-ufrn",
  storageBucket: "circular-ufrn.appspot.com",
  messagingSenderId: "188902688357",
  appId: "1:188902688357:web:c23c04b2faab8195c0a88c",
  measurementId: "G-L1C8SRX01G",
};

const webConfig = {
  apiKey: "AIzaSyDxl-YKbcIp84f2rjENdySY6lJwVjQzrTU",
  authDomain: "circular-ufrn.firebaseapp.com",
  databaseURL: "https://circular-ufrn.firebaseio.com",
  projectId: "circular-ufrn",
  storageBucket: "circular-ufrn.appspot.com",
  messagingSenderId: "188902688357",
  appId: "1:188902688357:web:db5ee182eea58f5bc0a88c",
  measurementId: "G-VETERW5Q5J",
};

const firebaseConfig =
  "cordova" in window
    ? cordovaConfig
    : window.matchMedia("(display-mode: standalone)").matches
    ? pwaConfig
    : webConfig;

const app = initializeApp(firebaseConfig);

export default app;
